import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AutoResetDonationFlow } from './-components/flows/auto-reset-donation-flow';
import { StandaloneDonationsFlow } from './-components/flows/standalone-donations-flow';
import { UpdatePortalOnConfirmedDonationFlow } from './-components/flows/update-portal-on-confirmed-donation-flow';

export const Route = createFileRoute('/$portalId')({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<>
			<AutoResetDonationFlow />
			<StandaloneDonationsFlow />
			<UpdatePortalOnConfirmedDonationFlow />
			<Outlet />
		</>
	);
}
